export const ASSET_CLASS = 'Asset Class'
export const INVESTMENT_STRATEGY = 'Investment Strategy'
